module.exports = __webpack_public_path__ + "img/home-hero-photo.8b35c659.jpg";